export const RC_LOAD_APP = "/";

// auth bash constans
export const RC_AUTH_BASE_URL = "/auth";
export const RC_LOAD_LOGIN = `${RC_AUTH_BASE_URL}/login`;
export const RC_LOAD_LOGOUT = `${RC_AUTH_BASE_URL}/logout`;

export const ACCOUNT_FILE = '/accounts'
export const ACCOUNT_CREATE = '/accounts/create'
export const ACCOUNT_DASHBOARD = `${ACCOUNT_FILE}/dashboard`
// export const ADD_ACCOUNT_INFORMATION = `${ACCOUNT_FILE}/add-account-info`


export const ADDITIONAL_ACCOUNT_INFO = `/account-info`
export const CARRIER = '/carrier'
export const CARRIER_DASHBOARD = `${CARRIER}/dashboard`

export const CARRIER_INFO = `${CARRIER}/gateways`

export const CDR_BILLING = '/cdr-billing'

export const AGENT_SECTION = '/agents-list'

export const SUBJECT_BLOCK = '/subject-block'

export const REPORTS_BASE_URL = '/reports'
export const REPORTS_MAIN = `${REPORTS_BASE_URL}`
export const REPORTS_BALANCE = `${REPORTS_BASE_URL}/balance`
export const REPORTS_ACCOUNT_STATS = `${REPORTS_BASE_URL}/account-stats`
export const ACCOUNTS_PER_DAY = `${REPORTS_ACCOUNT_STATS}`
export const REPORTS_CARRIER_STATS = `${REPORTS_BASE_URL}/carrier-stats`
export const CARRIER_PER_DAY = `${REPORTS_CARRIER_STATS}`
export const REPORTS_ACCOUNT_REJECTION = `${REPORTS_BASE_URL}/account-rejection`
export const REPORTS_TRAFFIC_STATS = `${REPORTS_BASE_URL}/traffic-stats`
export const REPORTS_CARRIER_MEDIA_STATS = `${REPORTS_BASE_URL}/carrier-media-stats`


// export const ROUTING_BASE_URL = '/routing'
// export const ROUTING_URL = `${ROUTING_BASE_URL}`

export const RATEDECK_BASE_URL = '/ratedeck'

export const INVOICE_BASE = '/invoice'
export const INVOICE_BASE_URL = `${INVOICE_BASE}/main`
export const INVOICE_AGENT_BASE_URL = `${INVOICE_BASE}/agent`
export const INVOICE_EMAIL_HISTORY_URL = `${INVOICE_BASE}/email-history`

export const ROUTE_BASE_URL = `/routing`
export const CREATE_RATEDECK_URL = `${ROUTE_BASE_URL}/create-ratedeck`
export const FIND_ROUTE_URL = `${ROUTE_BASE_URL}/find-route`
export const CALL_RESTRICTION = `${ROUTE_BASE_URL}/call-restriction`
export const MEDIA_ROUTING_URL = `${ROUTE_BASE_URL}/media-ip-block`



export const RC_ERROR_404 = "/error404";


// Add url to redirect to user side from admin
export const USER_URL = `https://customer.directccs.com`;
